import { render, staticRenderFns } from "./AddExerciseCard.vue?vue&type=template&id=1c2f7138&scoped=true"
import script from "./AddExerciseCard.vue?vue&type=script&lang=js"
export * from "./AddExerciseCard.vue?vue&type=script&lang=js"
import style0 from "./AddExerciseCard.vue?vue&type=style&index=0&id=1c2f7138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2f7138",
  null
  
)

export default component.exports